import { State } from "./state";
import { MutationTree } from "vuex";
import {
  IS_LOADING,
  SET_ERROR,
  SET_SUCCESS,
  SET_DATA_ITEM,
  IS_CONSUMER_VIEW,
  SET_LOGO,
  SET_LAST_USER_ACTION_TIMESTAMP,
  SET_TERMS_OF_USE_ACCEPTED_AT,
  SET_APP_VERSION,
} from "./types";
import { isNull } from "lodash";
import { CrudState } from "@/store/crud/State";

export default <MutationTree<State>>{
  [IS_LOADING](state: State, isLoading: boolean) {
    Object.assign(state, { isLoading });
  },

  [IS_CONSUMER_VIEW](state: State, isConsumerView: boolean) {
    Object.assign(state, { isConsumerView });
  },

  [SET_ERROR](state: State, error: Record<string, any>) {
    Object.assign(state, { error });
  },

  [SET_SUCCESS](state: State, success: Record<string, any>) {
    Object.assign(state, { success });
  },

  [SET_DATA_ITEM](state: State, dataItem: Record<string, any>) {
    Object.assign(state, { dataItem });
  },

  [SET_LOGO](state: State, logo: any) {
    Object.assign(state, { logo });
  },

  [SET_LAST_USER_ACTION_TIMESTAMP](
    state: State,
    lastUserActionTimestamp: number | null = null
  ) {
    if (isNull(lastUserActionTimestamp)) {
      lastUserActionTimestamp = Date.now();
    }
    Object.assign(state, { lastUserActionTimestamp });
  },
  [SET_TERMS_OF_USE_ACCEPTED_AT](state: State, acceptedAt: Date | null) {
    state.dataItem.termsOfUseAcceptedAt = acceptedAt;
  },
  [SET_APP_VERSION](state: State, appVersion: any) {
    Object.assign(state, { appVersion });
  },
};
